import { useCallback } from 'react';
import { useAsync } from './useAsync';
import {
  getTemplateInFormat,
  listFormats,
  listTemplatesForFormat,
} from '@/services/formats';
import type { FormatListItem, Template, TemplateSummary } from '@/types/api';

export function useFormats() {
  const fn = useCallback(() => listFormats(), []);
  return useAsync<FormatListItem[]>(fn);
}

export function useTemplatesForFormat(formatPathId: string | null) {
  const fn = useCallback(() => {
    if (!formatPathId) return Promise.reject(new Error('No format'));
    return listTemplatesForFormat(formatPathId).then((page) => page.items);
  }, [formatPathId]);
  return useAsync<TemplateSummary[]>(formatPathId ? fn : null);
}

export function useTemplateInFormat(formatPathId: string | null, templateId: string | null) {
  const fn = useCallback(() => {
    if (!formatPathId || !templateId) return Promise.reject(new Error('Missing ids'));
    return getTemplateInFormat(formatPathId, templateId);
  }, [formatPathId, templateId]);
  return useAsync<Template>(formatPathId && templateId ? fn : null);
}
